import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.50484 17.9907L14.4688 12L8.50484 6.00935C7.97408 5.47621 8.03757 4.59683 8.6394 4.14545C9.13299 3.77526 9.8238 3.825 10.2593 4.26207L17.9688 12L10.2593 19.7379C9.8238 20.175 9.13298 20.2247 8.6394 19.8546C8.03757 19.4032 7.97408 18.5238 8.50484 17.9907Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronRight);
